import type ArticleLocal from "~/libs/interfaces/ArticleLocal"
import {TemplateList} from "~/libs/constants/TemplateList"

/**
 * Extrahuje keywords z article.keywordList (GraphQL).
 * Fallback na site-level keywords podle template, když není article.
 */
export const useSiteKeywords = (article?: ArticleLocal | null): string[] => {
  if (article?.keywordList?.edges?.length) {
    return article.keywordList.edges
      .map((edge) => edge?.node?.name)
      .filter((name): name is string => !!name)
  }

  const template = useUniWebTemplate().getTemplateListItem()
  switch (template) {
    case TemplateList.POGGERS:
      return ['poggers']
    case TemplateList.MATERIDOUSKA:
      return ['materidouska']
    default:
      return []
  }
}
